var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clickable",on:{"click":function($event){_vm.onClick()}}},[_c('i',{staticClass:"reply icon m-r-5"}),_vm._v(" \n  "+_vm._s(_vm.historyBack ? "Voltar" : _vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }